<app-dialog-header
  [title]="('scheduler.setup.zone-overlay.title' | translate) + ' ' + (data.zone ? data.zone.name : 'Unnamed')"
  (closeClicked)="onCancelClick()">
</app-dialog-header>

<ngx-ui-loader [loaderId]="'zoneEditLoader'"></ngx-ui-loader>
<mat-dialog-content class="fullscreen-dialog">

  <form [formGroup]="zoneForm">
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Name</mat-label>
      <input formControlName="name" title="Zone Name" matInput [placeholder]="'Enter zone name'"
        [attr.aria-label]="'Zone name'">
    </mat-form-field>
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Ordinal</mat-label>
      <input title="Ordinal" formControlName="ordinal" matInput [placeholder]="'Enter ordinal number'"
        [attr.aria-label]="'Zone ordinal'" type="number">
    </mat-form-field>

    <div class="color-row">
      <div class="color-container">
        <label class="color-label">Fill Colour</label>
        <input title="Fill colour" (colorPickerChange)="colourChanged()" [(colorPicker)]="fillColour"
          [style.background]="fillColour" class="color-field" cpPosition="top" [attr.aria-label]="'Fill color'"
          [title]="'Choose fill color'" />
      </div>
      <div class="color-container">
        <label class="color-label">Border Colour</label>
        <input title="Border colour" (colorPickerChange)="colourChanged()" [(colorPicker)]="strokeColour"
          [style.background]="strokeColour" class="color-field" cpPosition="top" [attr.aria-label]="'Border color'"
          [title]="'Choose border color'" />
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="start">
  <button (click)="onDeleteClick()" color="warn" mat-flat-button>{{ 'scheduler.general.delete' | translate }}</button>
  <span class="spacer"></span>
  <button mat-dialog-close="" mat-flat-button type="reset">{{ 'scheduler.general.undo' | translate }}</button>
  <button (click)="save()" [disabled]="zoneForm.pristine" color="primary" mat-raised-button type="submit">Save</button>
</mat-dialog-actions>